export enum LeaseRenewalStatus {
  Offered = 'offered',
  Signing = 'signing',
  Finalized = 'finalized',
  Rejected = 'rejected',
  Retracted = 'retracted',
}

export interface LeaseRenewalOffer {
  id: string;
  status: LeaseRenewalStatus;
  newRent: number;
  newEndDate?: string;
  month2Month: boolean;
  offerExpires?: string;
}
